import axios from "axios";

export const controlEventApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/control-event`,
  headers: {
    "Content-Type": "application/json",
  },
});
